import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core'

import { ResultCode } from '../../../domain/authentication.model'
import { CheckFileResponse } from '../../../domain/check-file-response'
import { AuthService } from '../../../services/auth.service'
import { CoreEnvironmentService } from '../../../services/core-environment.service'
import { CurrencySignType, I18nService } from '../../../services/prod/i18n.service'
import { PurchaseService } from '../../../services/purchase.service'
import { PurchasesPopupService } from '../../../services/purchases-popup.service'
import { FileType, PurchasedTrackType } from '../../../types/purchased-track.type'

class DownloadingState {
  constructor(
    public percents: number = 0,
    public error: null | string = null
  ) {}

  readyToDownloading() {
    return this.percents === 100 && !this.error
  }

  isPreparing() {
    return this.percents !== 100 && !this.error
  }

  hasError() {
    return !!this.error
  }
}

@Component({
  selector: 'bmcore-purchased-track',
  templateUrl: './bmcore-purchased-track.component.html',
  styleUrls: ['./bmcore-purchased-track.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePurchasedTrackComponent implements OnInit {
  @Input() track: PurchasedTrackType
  @Input() hash: string | null = null
  @Input() userId: number | null = null

  buyerId: number
  baseUrl: string
  downloadLicenseURL: string
  isPurchaseTrackExpanded = false
  currencySign: CurrencySignType
  mobMode = false
  public filesReadyValues: { [fileId: string]: DownloadingState } = {}

  constructor(
    private purchaseService: PurchaseService,
    private coreEnvironmentService: CoreEnvironmentService,
    private authService: AuthService,
    private purchasesPopupService: PurchasesPopupService,
    private i18nService: I18nService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
    this.downloadLicenseURL = `${this.baseUrl}/BeatsManagement/BeatsSales/DownloadContract`
  }

  ngOnInit(): void {
    this.currencySign = this.i18nService.getCurrencySign()
    this.authService.user.subscribe(res => {
      this.buyerId = res.id
    })
    this.onResize()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    const mobViewPort = 767
    this.mobMode = window.innerWidth < mobViewPort
  }

  downloadFilesHandler(track: PurchasedTrackType) {
    if (track.files.length) {
      this.isPurchaseTrackExpanded = !this.isPurchaseTrackExpanded
      track.files.forEach(file => {
        this.checkFile(file, track)
      })
    } else {
      this.purchasesPopupService.notify({ reason: 'files', track })
    }
  }

  checkFile(file: FileType, track: PurchasedTrackType) {
    if (!this.filesReadyValues[file.id]) {
      this.filesReadyValues[file.id] = new DownloadingState()
    }

    if (this.filesReadyValues[file.id].percents === 100) {
      return
    }

    this.purchaseService.checkFilesStatus(track.beatId, file.id, track.paymentId).subscribe(
      (res: CheckFileResponse) => {
        if (res.resultCode === ResultCode.Success) {
          if (res.data.percents < 100) {
            this.filesReadyValues[file.id].percents = res.data.percents
            setTimeout(() => {
              this.checkFile(file, track)
            }, 500)
          } else {
            this.filesReadyValues[file.id].percents = 100
            file.size = res.data.size
          }
        } else {
          this.filesReadyValues[file.id].error = res.messages[0]
        }
      },
      err => {
        this.filesReadyValues[file.id].error = `File is not available`
      }
    )
  }

  tryCheckFileAgain(file: FileType, track: PurchasedTrackType) {
    delete this.filesReadyValues[file.id]
    this.checkFile(file, track)
  }

  closePopup() {
    this.isPurchaseTrackExpanded = false
  }
}
